import colors from './colors';
import borderRadius from './borderRadius';
import navigation from './navigation';
import greys from './greys';
import header from './header';
import sidebar from './sidebar';
import card from './card';
import space from './space';

const theme = {
    colors,
    greys,
    borderRadius,
    navigation,
    header,
    sidebar,
    card,
    space
};

export default theme;
